import React from 'react'
import { Empty } from 'antd'
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react'
import moment from 'moment'
import { formatShiftDayLabel } from './shiftDateUtils'
import {
    getShiftBadgeClassByName,
    resolveShiftSlotLabel,
} from './shiftLabelUtils'

function ShiftWeekMobile({
    staffshift,
    shiftDefs,
    weekDays,
    lang,
    frameLabel,
    periodLabel,
    monthLabel,
    onPrevWeek,
    onNextWeek,
    onPrevMonth,
    onNextMonth,
    emptyText,
}) {
    const formatDayLabel = (day, index) => formatShiftDayLabel(day, index, lang)

    return (
        <div className="shift-week-mobile">
            <div className="shift-week-mobile__month-nav">
                <a role="button" className="lh1 flex_item_cc" onClick={onPrevMonth}>
                    <ArrowLeft2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
                <h6>{monthLabel}</h6>
                <a role="button" className="lh1 flex_item_cc" onClick={onNextMonth}>
                    <ArrowRight2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
            </div>
            <div className="shift-week-mobile__week-nav">
                <a role="button" className="lh1 flex_item_cc" onClick={onPrevWeek}>
                    <ArrowLeft2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
                <h6>{periodLabel}</h6>
                <a role="button" className="lh1 flex_item_cc" onClick={onNextWeek}>
                    <ArrowRight2 variant="Bold" color="#0D0B0B" size="24" />
                </a>
            </div>

            {staffshift?.length ? (
                <div className="mobile-list">
                    {staffshift.map((staff) => (
                        <div
                            key={staff?._id?.staffId || staff?.name}
                            className="border_card mb16"
                        >
                            <h6 className="shift-week-mobile__staff-name">{staff.name}</h6>
                            <ul className="details_list">
                                {weekDays.map((day, index) => {
                                    const dateKey = moment(day).format('YYYY-MM-DD')
                                    const shifts = staff?.shiftData?.[dateKey]
                                    const activeShifts = Array.isArray(shifts)
                                        ? shifts.filter((s) => s !== '')
                                        : []

                                    return (
                                        <li key={dateKey}>
                                            <label className="fs-16">
                                                {formatDayLabel(day, index)}
                                            </label>
                                            <span className="shift-week-mobile__shift-values">
                                                {activeShifts.length ? (
                                                    activeShifts.map((code, ind) => (
                                                        <span
                                                            key={ind}
                                                            className={`shift_badge shift_badge--labeled ${getShiftBadgeClassByName(code)}`}
                                                        >
                                                            {resolveShiftSlotLabel(code, shiftDefs, {
                                                                lang,
                                                                frameLabel,
                                                            })}
                                                        </span>
                                                    ))
                                                ) : (
                                                    <span className="text-gray">—</span>
                                                )}
                                            </span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    ))}
                </div>
            ) : (
                <Empty description={emptyText} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </div>
    )
}

export default ShiftWeekMobile
